module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard-container-new"
  }, [_c('div', {
    staticClass: "top-section"
  }, [_c('div', {
    staticClass: "welcome-card-new"
  }, [_c('div', {
    staticClass: "user-info-new"
  }, [_c('el-image', {
    staticClass: "user-avatar-new",
    attrs: {
      "src": _vm.getCurrentUserAvater,
      "alt": "头像预览",
      "preview-src-list": [_vm.getCurrentUserAvater],
      "fit": "cover"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "user-text-new"
  }, [_c('h2', {
    staticClass: "welcome-title-new"
  }, [_vm._v("\n            " + _vm._s(_vm.getCurrentTimeDesc) + "，" + _vm._s(_vm.getCurrentUser) + "！欢迎登录\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "welcome-subtitle-new"
  }, [_vm._v("\n            一站式智能管理解决方案，帮助您高效管理客户、快速提升业绩\n          ")])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "data-dashboard-section"
  }, [_c('div', {
    staticClass: "dashboard-header"
  }, [_c('div', {
    staticClass: "header-content"
  }, [_c('h2', {
    staticClass: "dashboard-title"
  }, [_c('i', {
    staticClass: "el-icon-data-analysis"
  }), _vm._v("\n          " + _vm._s(_vm.currentYear) + "年度经营数据看板\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "header-actions"
  }, [_c('el-tag', {
    attrs: {
      "type": "success",
      "effect": "plain"
    }
  }, [_vm._v("实时更新")]), _vm._v(" "), _c('el-button', {
    staticClass: "refresh-btn",
    attrs: {
      "size": "mini",
      "type": "primary",
      "icon": "el-icon-refresh"
    },
    on: {
      "click": _vm.refreshDashboard
    }
  }, [_vm._v("\n            刷新数据\n          ")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "metrics-grid"
  }, [_c('div', {
    staticClass: "metric-card clean",
    on: {
      "click": function($event) {
        return _vm.toggleDisplayValue('totalAmount')
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "metric-label"
  }, [_vm._v("年度销售额")]), _vm._v(" "), _c('div', {
    staticClass: "metric-value-wrapper"
  }, [_c('span', {
    staticClass: "currency-symbol"
  }, [_vm._v("¥")]), _vm._v(" "), _c('span', {
    staticClass: "metric-value-display",
    class: {
      'original': _vm.displayMode.totalAmount
    }
  }, [_vm._v("\n              " + _vm._s(_vm.displayMode.totalAmount ?
    _vm.formatNumber(_vm.businessOverviewData.totalAmount || 0) :
    _vm.formatShortNumber(Number(_vm.businessOverviewData.totalAmount) || 0).value + _vm.formatShortNumber(Number(_vm.businessOverviewData.totalAmount) || 0).unit) + "\n            ")])]), _vm._v(" "), (_vm.businessOverviewData.amountGrowthRate !== 0) ? _c('div', {
    staticClass: "growth-info"
  }, [_c('span', {
    staticClass: "growth-text",
    class: _vm.businessOverviewData.amountGrowthRate > 0 ? 'positive' : 'negative'
  }, [_vm._v("\n              " + _vm._s(_vm.businessOverviewData.amountGrowthRate > 0 ? '+' : '') + _vm._s(_vm.businessOverviewData.amountGrowthRate.toFixed(2)) + "%\n            ")]), _vm._v(" "), _c('span', {
    staticClass: "growth-label"
  }, [_vm._v("同比去年")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "metric-card clean",
    on: {
      "click": function($event) {
        return _vm.toggleDisplayValue('orderCount')
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "metric-label"
  }, [_vm._v("订单总数")]), _vm._v(" "), _c('div', {
    staticClass: "metric-value-wrapper"
  }, [_c('span', {
    staticClass: "metric-value-display",
    class: {
      'original': _vm.displayMode.orderCount
    }
  }, [_vm._v("\n              " + _vm._s(_vm.displayMode.orderCount ?
    _vm.formatNumber(_vm.businessOverviewData.orderCount || 0) :
    _vm.formatShortNumber(_vm.businessOverviewData.orderCount || 0).value + _vm.formatShortNumber(_vm.businessOverviewData.orderCount || 0).unit) + "\n            ")]), _vm._v(" "), (!_vm.displayMode.orderCount) ? _c('span', {
    staticClass: "unit"
  }, [_vm._v("单")]) : _vm._e()]), _vm._v(" "), (_vm.businessOverviewData.orderGrowthRate !== 0) ? _c('div', {
    staticClass: "growth-info"
  }, [_c('span', {
    staticClass: "growth-text",
    class: _vm.businessOverviewData.orderGrowthRate > 0 ? 'positive' : 'negative'
  }, [_vm._v("\n              " + _vm._s(_vm.businessOverviewData.orderGrowthRate > 0 ? '+' : '') + _vm._s(_vm.businessOverviewData.orderGrowthRate.toFixed(2)) + "%\n            ")]), _vm._v(" "), _c('span', {
    staticClass: "growth-label"
  }, [_vm._v("同比去年")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "metric-card clean",
    on: {
      "click": function($event) {
        return _vm.toggleDisplayValue('customerCount')
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "metric-label"
  }, [_vm._v("新增客户")]), _vm._v(" "), _c('div', {
    staticClass: "metric-value-wrapper"
  }, [_c('span', {
    staticClass: "metric-value-display",
    class: {
      'original': _vm.displayMode.customerCount
    }
  }, [_vm._v("\n              " + _vm._s(_vm.displayMode.customerCount ?
    _vm.formatNumber(_vm.businessOverviewData.customerCount || 0) :
    _vm.formatShortNumber(_vm.businessOverviewData.customerCount || 0).value + _vm.formatShortNumber(_vm.businessOverviewData.customerCount || 0).unit) + "\n            ")]), _vm._v(" "), (!_vm.displayMode.customerCount) ? _c('span', {
    staticClass: "unit"
  }, [_vm._v("人")]) : _vm._e()]), _vm._v(" "), (_vm.businessOverviewData.customerGrowthRate !== 0) ? _c('div', {
    staticClass: "growth-info"
  }, [_c('span', {
    staticClass: "growth-text",
    class: _vm.businessOverviewData.customerGrowthRate > 0 ? 'positive' : 'negative'
  }, [_vm._v("\n              " + _vm._s(_vm.businessOverviewData.customerGrowthRate > 0 ? '+' : '') + _vm._s(_vm.businessOverviewData.customerGrowthRate.toFixed(2)) + "%\n            ")]), _vm._v(" "), _c('span', {
    staticClass: "growth-label"
  }, [_vm._v("同比去年")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "metric-card clean",
    on: {
      "click": function($event) {
        return _vm.toggleDisplayValue('totalProductCount')
      }
    }
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "metric-label"
  }, [_vm._v("累销产品")]), _vm._v(" "), _c('div', {
    staticClass: "metric-value-wrapper"
  }, [_c('span', {
    staticClass: "metric-value-display",
    class: {
      'original': _vm.displayMode.totalProductCount
    }
  }, [_vm._v("\n              " + _vm._s(_vm.displayMode.totalProductCount ?
    _vm.formatNumber(_vm.businessOverviewData.totalProductCount || 0) :
    _vm.formatShortNumber(_vm.businessOverviewData.totalProductCount || 0).value + _vm.formatShortNumber(_vm.businessOverviewData.totalProductCount || 0).unit) + "\n            ")]), _vm._v(" "), (!_vm.displayMode.totalProductCount) ? _c('span', {
    staticClass: "unit"
  }, [_vm._v("件")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "highlight-tag"
  }, [_vm._v("\n            核心SKU\n          ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "main-content-section"
  }, [_c('el-row', {
    staticClass: "chart-row",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    staticClass: "chart-col",
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12,
      "xl": 12
    }
  }, [_c('div', {
    staticClass: "chart-area"
  }, [_c('div', {
    staticClass: "chart-header-new"
  }, [_c('h3', {
    staticClass: "chart-title-new"
  }, [_vm._v("销售额汇总分析")]), _vm._v(" "), _c('div', {
    staticClass: "chart-filter"
  }, [_c('el-select', {
    staticClass: "filter-select-small",
    attrs: {
      "placeholder": "选择年份",
      "size": "small"
    },
    on: {
      "change": _vm.handleSalesYearChange
    },
    model: {
      value: (_vm.selectedYear),
      callback: function($$v) {
        _vm.selectedYear = $$v
      },
      expression: "selectedYear"
    }
  }, _vm._l((_vm.yearOptions), function(year) {
    return _c('el-option', {
      key: year,
      attrs: {
        "label": year,
        "value": year
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "chart-content-new"
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.amountLoading),
      expression: "amountLoading"
    }],
    staticClass: "chart-container-new",
    attrs: {
      "id": "sales_chart"
    }
  })])])]), _vm._v(" "), _c('el-col', {
    staticClass: "chart-col",
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12,
      "xl": 12
    }
  }, [_c('div', {
    staticClass: "chart-area"
  }, [_c('div', {
    staticClass: "chart-header-new"
  }, [_c('h3', {
    staticClass: "chart-title-new"
  }, [_vm._v("热门销售产品TOP10")]), _vm._v(" "), _c('div', {
    staticClass: "chart-filter"
  }, [_c('el-select', {
    staticClass: "filter-select-small",
    attrs: {
      "placeholder": "选择年份",
      "size": "small"
    },
    on: {
      "change": _vm.handleProductYearChange
    },
    model: {
      value: (_vm.selectedProductYear),
      callback: function($$v) {
        _vm.selectedProductYear = $$v
      },
      expression: "selectedProductYear"
    }
  }, _vm._l((_vm.yearOptions), function(year) {
    return _c('el-option', {
      key: year,
      attrs: {
        "label": year,
        "value": year
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "chart-content-new"
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.amountLoading),
      expression: "amountLoading"
    }],
    staticClass: "chart-container-new",
    attrs: {
      "id": "product_chart"
    }
  })])])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "chart-row mt-20",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    staticClass: "chart-col",
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12,
      "xl": 12
    }
  }, [_c('div', {
    staticClass: "chart-area"
  }, [_c('div', {
    staticClass: "chart-header-new"
  }, [_c('h3', {
    staticClass: "chart-title-new"
  }, [_vm._v("订单趋势")]), _vm._v(" "), _c('div', {
    staticClass: "chart-filter"
  }, [_c('el-select', {
    staticClass: "filter-select-small",
    attrs: {
      "placeholder": "选择年份",
      "size": "small"
    },
    on: {
      "change": _vm.handleOrderYearChange
    },
    model: {
      value: (_vm.selectedOrderYear),
      callback: function($$v) {
        _vm.selectedOrderYear = $$v
      },
      expression: "selectedOrderYear"
    }
  }, _vm._l((_vm.yearOptions), function(year) {
    return _c('el-option', {
      key: year,
      attrs: {
        "label": year,
        "value": year
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "chart-content-new"
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.amountLoading),
      expression: "amountLoading"
    }],
    staticClass: "chart-container-new",
    attrs: {
      "id": "order_chart"
    }
  })])])]), _vm._v(" "), _c('el-col', {
    staticClass: "chart-col",
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12,
      "xl": 12
    }
  }, [_c('div', {
    staticClass: "chart-area"
  }, [_c('div', {
    staticClass: "chart-header-new"
  }, [_c('h3', {
    staticClass: "chart-title-new"
  }, [_vm._v("客户趋势")]), _vm._v(" "), _c('div', {
    staticClass: "chart-filter"
  }, [_c('el-select', {
    staticClass: "filter-select-small",
    attrs: {
      "placeholder": "选择年份",
      "size": "small"
    },
    on: {
      "change": _vm.handleCustomYearChange
    },
    model: {
      value: (_vm.selectedCustomYear),
      callback: function($$v) {
        _vm.selectedCustomYear = $$v
      },
      expression: "selectedCustomYear"
    }
  }, _vm._l((_vm.yearOptions), function(year) {
    return _c('el-option', {
      key: year,
      attrs: {
        "label": year,
        "value": year
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "chart-content-new"
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.amountLoading),
      expression: "amountLoading"
    }],
    staticClass: "chart-container-new",
    attrs: {
      "id": "customer_chart"
    }
  })])])])], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-icon sales-simple"
  }, [_c('i', {
    staticClass: "el-icon-shopping-cart-2"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-icon orders-simple"
  }, [_c('i', {
    staticClass: "el-icon-document"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-icon customers-simple"
  }, [_c('i', {
    staticClass: "el-icon-user"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-icon products-simple"
  }, [_c('i', {
    staticClass: "el-icon-goods"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f089a07"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/charts/echarts.vue
// module id = 1000
// module chunks = 3